import {buildGroupPayload} from './filters';
import {applyUserDefaultTime} from './picker_user_time';

$(document).ready(function (e) {

    let $body = $('body'),
        $modal = $('#bulk-create-modal');

    if (!$modal.length) {
        return;
    }

    let $container = $modal.find('.criteria-group-container'),
        blank_criteria = $container.html();

    /**
     * Bind the pickers on criteria rows that arrived over ajax. The page load
     * pass in app.js only ever sees the markup that was there at ready time.
     */
    function initCriteriaWidgets() {
        let date_format = $('meta[name="date-format"]').attr('content');

        $container.find('.selectpicker').selectpicker({
            noneSelectedText: translation.nothing_selected
        });

        $container.find('.datepicker-cl').flatpickr({
            weekNumbers: true,
            dateFormat: date_format
        });

        $container.find('.datetimepicker-cl').flatpickr({
            weekNumbers: true,
            dateFormat: date_format + ' H:i',
            enableTime: true,
            onOpen: applyUserDefaultTime
        });
    }

    $body.on('click', '#bulk-create', function (e) {
        e.preventDefault();
        $modal.modal('show');
    });

    $modal.on('shown.bs.modal', function () {
        $modal.find('.selectpicker').selectpicker('refresh');
    });

    $body.on('changed.bs.select', '#bulk-create-filter', function (e) {
        let filter_id = $(this).val(),
            table_id = $(this).attr('data-table-id');

        if (!filter_id) {
            $container.html(blank_criteria);
            initCriteriaWidgets();
            return;
        }

        $.ajax({
            type: 'GET',
            url: `/filter/${table_id}/${filter_id}/criteria`,
            success: function (res) {
                $container.html(res);
                initCriteriaWidgets();
            },
            error: function () {
                toastr.error(translation.filter_criteria_failed);
            }
        });
    });

    $body.on('changed.bs.select', '#bulk-create-button', function (e) {
        let related_table = $(this).find(':selected').attr('data-related-table'),
            $target = $('#bulk-create-target');

        if (related_table) {
            $target.find('span').text(related_table);
            $target.removeClass('d-none');
        } else {
            $target.addClass('d-none');
        }
    });

    $body.on('click', '#bulk-create-submit', function (e) {
        e.preventDefault();

        let $this = $(this),
            table_id = $this.attr('data-table-id'),
            group_field = $('#bulk-create-group-field').val(),
            button_id = $('#bulk-create-button').val();

        if (!group_field) {
            alert(translation.select_group_field);
            return;
        }

        if (!button_id) {
            alert(translation.select_action_button);
            return;
        }

        let {group_payload, error} = buildGroupPayload($modal.find('.criteria-group'));

        if (error) {
            return;
        }

        $this.prop('disabled', true);

        $.ajax({
            type: 'POST',
            url: '/tables/bulk_create',
            data: {
                table_id,
                button_id,
                group_field,
                group_payload
            },
            success: function (res) {
                if (res.status) {
                    toastr.success(res.message);

                    if (res.skipped) {
                        toastr.warning(
                            translation.bulk_create_skipped.replace(':count', res.skipped)
                        );
                    }

                    $modal.modal('hide');
                    window.location.reload();
                } else {
                    toastr.error(res.message);
                }
            },
            complete: function () {
                $this.prop('disabled', false);
            }
        });
    });
});